import App from 'modules/App';
import Account from 'modules/Account';
import Information from 'modules/Information';
import Integration from 'modules/Integration';
import Organization from 'modules/Organization';
export function getCoreSagas() {
    return {
        [App.constants.MODULE_ID]: App.sagas,
        [Account.constants.MODULE_ID]: Account.sagas,
        [Information.constants.MODULE_ID]: Information.sagas,
        [Integration.constants.MODULE_ID]: Integration.sagas,
        [Organization.constants.MODULE_ID]: Organization.sagas
    };
}
